module.exports = __webpack_public_path__ + "static/media/sneakers.dad7221e.jpg";